<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">姓名</label>
            <em class="weui-form-preview__value">{{form.main.em_name}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.roles">
            <label class="weui-form-preview__label">岗位</label>
            <span class="weui-form-preview__value">
              <span
                class="list-item-status"
                v-for="role in form.main.roles"
                :key="role.id"
              >{{role.name}}</span>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">部门</label>
            <span class="weui-form-preview__value">{{form.main.dp_name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">手机</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.em_mobile}}
              <call-mobile :mobile="form.main.em_mobile"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">邮箱</label>
            <span class="weui-form-preview__value">{{form.main.em_email}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">身份证号</label>
            <span class="weui-form-preview__value">{{form.main.em_id_card}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">性别</label>
            <span class="weui-form-preview__value">{{form.main.em_sex}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">婚姻状态</label>
            <span class="weui-form-preview__value">{{form.main.em_marital}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">学历</label>
            <span class="weui-form-preview__value">{{form.main.em_xl}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">专业</label>
            <span class="weui-form-preview__value">{{form.main.em_zy}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">毕业院校</label>
            <span class="weui-form-preview__value">{{form.main.em_byschool}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">入职时间</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.em_entry_time}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">转正时间</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.em_positivetime}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">合同开始时间</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.em_co_starttime}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">合同截止时间</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.em_co_endtime}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">紧急联系人</label>
            <span class="weui-form-preview__value">{{form.main.em_emergencyname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人关系</label>
            <span class="weui-form-preview__value">{{form.main.em_emergencygx}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人电话</label>
            <span class="weui-form-preview__value">{{form.main.em_emergencytel}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/document/employee_edit?id='+form.main.id"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="form.main.em_class=='正式'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_enable(0)"
      >禁用</a>
      <a
        href="javascript:;"
        v-if="form.main.em_class!='正式'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_enable(1)"
      >启用</a>
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="f_remove">删除</a>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [form],
  components: {
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/document/employee",
    };
  },
  methods: {
    /**
     * 读取数据，原read接口返回的数据不完整，改为使用list接口
     * @override
     */
    f_get(callback, id) {
      var me = this;
      id = id || me.initId || me.$route.params.id || me.$route.query.id;
      if (id) {
        me.$loading({
          url: me.baseUrl + "/list",
          params: {
            condition: JSON.stringify({
              field: "em_id",
              operation: "=",
              value: id,
            }),
          },
        }).then(function (res) {
          if (res.success) {
            me.form.main = res.data.list[0];
            if (callback && typeof callback === "function") {
              callback.call(me, me.form);
            }
          } else {
            me.$router.push({
              name: "Error",
              params: res
            });
          }
        });
      } else if (me.initData) {
        me.form.main = me.initData;
      }
    },
    /**
     *   重写删除人员后的路由跳转
     */
    f_delete(callback, id) {
        var me = this, main = me.form.main || me.form;
        id = id || main[me.idField];
        me.$loading({
            url: me.baseUrl + '/delete/' + id,
            method: 'POST'
        }).then(function (res) {
            if (res.success) {
                me.$weui.toast("删除成功", 2000);
                if (callback && typeof callback === 'function') {
                    callback.call(me);
                } else {
                    me.$router.back()
                }
            } else {
                me.$weui.topTips("删除失败: " + res.message, 3000);
            }
        }).catch(function () {
            me.$weui.topTips("删除失败", 3000);
        });
    },
  },
};
</script>